export default {
  data () {
    return {
      usedTemplate: {},
      displayedComponents: {},
      selectedInvoiceFee: {},
      invoice: {
        subject: null,
        description: null,
        notes: null,
        conditions: null,
        text_description: null,
        currency_id: null,
        prefix: null,
        date: this.$dayjs().utc(true).toDate()
      }
    };
  },

  created () {
    this.initializeUsedTemplate();
    this.initializeDisplayedComponents();
    this.initializeUsedInvoice();
  },

  methods: {
    updateUsedTemplate (e) {
      this.usedTemplate = this.voucherTemplates["Invoice"].find((template) => template.id === e);
      this.initializeDisplayedComponents();
    },

    initializeDisplayedComponents () {
      this.$set(this.displayedComponents, "subject", !!this.resource.subject || this.usedTemplate.display_subject);
      this.$set(this.displayedComponents, "description", !!this.resource.text_description || this.usedTemplate.display_description);
      this.$set(this.displayedComponents, "attachments", !!Object.keys(this.resource.description).length || this.usedTemplate.display_attachments);
      this.$set(this.displayedComponents, "lineItems", !!this.resource.line_items.length || this.usedTemplate.display_line_items);
      this.$set(this.displayedComponents, "notes", !!this.resource.notes || this.usedTemplate.display_notes);
      this.$set(this.displayedComponents, "conditions", !!this.resource.conditions || this.usedTemplate.display_terms);
    },

    initializeUsedInvoice () {
      this.invoice = { ...this.invoice, ...this.$_.cloneDeep(this.resource) };
      this.invoice.date = this.$dayjs().utc(true).toDate();
      this.invoice.due_date = null;
      this.invoice.currency_id = this.invoice.currency_id || this.usedTemplate.merchant_base_currency.id;
      this.invoice.prefix = this.invoice.prefix || this.usedTemplate.invoice_number_prefix;
      this.invoice.subject = this.resource.subject || this.usedTemplate.default_subject;
      this.invoice.text_description = this.resource.text_description || this.usedTemplate.default_invoice_description;
      this.invoice.notes = this.resource.notes || this.usedTemplate.default_invoice_notes;
      this.invoice.conditions = this.resource.conditions || this.usedTemplate.default_invoice_terms_of_service;
      this.selectedInvoiceFee = this.invoiceFees.filter(fee => fee.currency_id === this.usedTemplate.merchant_base_currency.id)[0];
    },

    updateVisibility (e) {
      this.displayedComponents[e] = !this.displayedComponents[e];
    },

    applyNewTemplate () {
      if (this.invoice.id) {
        this.resetInvoiceWithTemplate();
      } else {
        this.initializeUsedInvoice();
      }
    },

    resetInvoiceWithTemplate () {
      this.invoice.date = this.$dayjs().utc(true).toDate();
      this.invoice.due_date = null;
      this.invoice.currency_id = this.usedTemplate.merchant_base_currency.id;
      this.invoice.prefix = this.usedTemplate.invoice_number_prefix;
      this.invoice.subject = this.usedTemplate.default_subject;
      this.invoice.text_description = this.usedTemplate.default_invoice_description;
      this.invoice.notes = this.usedTemplate.default_invoice_notes;
      this.invoice.conditions = this.usedTemplate.default_invoice_terms_of_service;
      this.selectedInvoiceFee = this.invoiceFees.filter(fee => fee.currency_id === this.usedTemplate.merchant_base_currency.id)[0];
    },

    updateSelectedInvoiceFee (e) {
      this.selectedInvoiceFee = this.invoiceFees.filter(fee => fee.currency_id.toString() === e)[0];
    }
  }
};
